import { WidgetDefinition, WidgetTextStyle } from "./common";
import WidgetType from "../enum/WidgetType";
import TickerSource from "../enum/TickerSource";
import Font from '../enum/Font';
import TextAlignment from '../enum/TextAlignment';

const Ticker: WidgetDefinition = {

    type: WidgetType.TICKER,
    className: 'widget-ticker',
    contentComponent: 'dmb-widget-content-ticker',

    settingsSectionComponents: [
        'dmb-section-widget-settings-ticker',
        'dmb-section-widget-style',
        'dmb-section-widget-animation'
    ],

    defaultSize: {
        width: 1.0,
        height: 0.05
    },

    defaultStyle: {
        opacity: 100,
        backgroundColor: 'FFFFFF'
    },

    defaultSettings: (options) => ({
        source: TickerSource.CUSTOM_TEXT,
        content: 'Nieuwe ticker',
        animationSpeed: 25,
        textStyle: {
            size: 20,
            font: Font.PRIMARY,
            color: '000000',
            alignment: null,
            bold: null,
            borderColor: null,
            borderSize: null,
            characterSpacing: null,
            customFont: 'Arial',
            italic: null,
            lineSpacing: null,
            shadowBlur: null,
            shadowColor: null,
            shadowOffsetX: null,
            shadowOffsetY: null,
            transform: null,
            underlined: null
        } as WidgetTextStyle
    })
}

export default Ticker
